import request from "../utils/request";
export function appList(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/iosAppInfo/all?${queryString}`,
        method: "get"
    });
}

export function getAppById(params) {
    return request({
        url: `/iosAppInfo/getById?id=${params.id}`,
        method: "get"
    });
}


export function deleteApp(params) {
    return request({
        url: `/iosAppInfo/delete?id=${params.id}`,
        method: "post"
    });
}

export function createApp(params) {
    return request({
        url: `/iosAppInfo/add`,
        method: "post",
        data: params
    });
}
export function editApp(params) {
    return request({
        url: `/iosAppInfo/update`,
        method: "post",
        data: params
    });
}